module.exports = __webpack_public_path__ + "img/ab-testing-dark.fc7532ad.svg";